/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { textPostTextConvert } from "../../funcs/textPostTextConvert.js";
import { PostTextConvertRequest$zodSchema } from "../../models/posttextconvertop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: PostTextConvertRequest$zodSchema,
};

export const tool$textPostTextConvert: ToolDefinition<typeof args> = {
  name: "text-post-text-convert",
  description: `格式转换

需要在不同文本格式之间转换？这个接口支持Base64、Hex、URL、HTML、Unicode等多种格式互转，还能生成MD5、SHA256等哈希值。

## 功能概述
你提供待转换的文本、源格式和目标格式，接口会自动完成转换。支持7种双向格式（plain、base64、hex、url、html、unicode、binary）和4种单向哈希（md5、sha1、sha256、sha512）。

## 格式说明
**双向转换格式**：plain（纯文本）、base64、hex（十六进制）、url、html（HTML实体）、unicode（\\uXXXX转义）、binary（二进制字符串）

**单向哈希格式**：md5、sha1、sha256、sha512（仅可作为目标格式，不可逆）

## 链式转换
支持多次调用实现复杂转换，如先将文本转为base64，再将base64转为hex。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await textPostTextConvert(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
